import React from "react";
import { Utensils, Clock, X } from "lucide-react";
import { useTableSession } from "../context/TableSessionContext";
import { useCart } from "../context/CartContext";

export default function TableRibbon() {
  const { table, isPreOrder, endSession } = useTableSession();
  const { setOpen } = useCart();

  if (!table) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[90] bg-[var(--mm-accent)] text-[var(--mm-bg)] flex items-center justify-center gap-3 py-2 px-4 shadow-lg"
      data-testid="table-ribbon"
    >
      {isPreOrder ? <Clock size={14} className="shrink-0" /> : <Utensils size={14} className="shrink-0" />}
      <div className="text-[0.72rem] tracking-[0.22em] uppercase font-semibold" data-testid="table-ribbon-copy">
        {isPreOrder
          ? "Pre-Order · Kitchen starts when you arrive"
          : `Seated at Table ${table} · Ordering direct to the kitchen`}
      </div>
      <button
        onClick={() => setOpen(true)}
        className="ml-2 text-[0.65rem] tracking-[0.2em] uppercase underline underline-offset-2 hover:opacity-70"
        data-testid="ribbon-open-cart"
      >
        Open menu
      </button>
      <button
        onClick={endSession}
        className="ml-1 opacity-70 hover:opacity-100"
        aria-label="End table session"
        data-testid="ribbon-end-session"
      >
        <X size={14} />
      </button>
    </div>
  );
}
